import http from 'hub-http/clients/apiClient';
import { DEAL_OBJECT_ID } from '../constants/CrmSearchConstants';
const BASE_URL = `properties/v4`;
export const fetchProperties = () => http.get(`${BASE_URL}/${DEAL_OBJECT_ID}`, {
  query: {
    includeFieldLevelPermission: true
  }
});
export const fetchPropertyGroups = () => http.get(`${BASE_URL}/groups/${DEAL_OBJECT_ID}`, {
  query: {
    includeFieldLevelPermission: true,
    includeProperties: true
  }
});

// TODO: type wizard store
// @ts-expect-error untyped
export const updateForecastCategories = options => http.patch(`${BASE_URL}/named/hs_manual_forecast_category`, {
  data: {
    objectTypeId: DEAL_OBJECT_ID,
    property: {
      options
    }
  }
});